(() => {
  angular
    .module('gm.common.services')
    .factory('gmTimezone', gmTimezoneFactory);

  function gmTimezoneFactory(
    btgUser,
    Timezones
  ) {
    'ngInject';

    const PARSE_ZONE_TO_OFFSET_REGEXP = /^([+-]?[01]?\d+)(?::([03][0]))$/;

    return {
      getTimezoneOffset,
      getTimezones,
      offsetToZone,
      zoneToOffset,
    };

    function detectTimezone() {
      return (new Date()).getTimezoneOffset() * -1;
    }

    function getTimezoneOffset() {
      const tz = btgUser.getProperty('timezone');

      return (angular.isUndefined(tz) || (tz === null)) ? detectTimezone() : tz;
    }

    function getTimezones() {
      return Timezones.map((tz) => {
        tz.zone = offsetToZone(tz.offset);

        return tz;
      });
    }

    function offsetToZone(offset) {
      let minutes = Math.abs(offset % 60);
      const sign = offset >= 0 ? '+' : '-';
      let hours = Math.abs(Math.floor(offset / 60));

      if (minutes < 10) {
        minutes = `0${minutes}`;
      }

      if (hours < 10) {
        hours = `0${hours}`;
      }

      return `${sign}${hours}:${minutes}`;
    }

    function zoneToOffset(zone) {
      const data = zone.toString().match(PARSE_ZONE_TO_OFFSET_REGEXP);
      let offset;

      if (!data) {
        return null;
      }

      if (data.length >= 1) {
        offset = parseInt(data[1], 10) * 60;
      }

      if (data.length > 1) {
        offset += (offset > 0 ? 1 : -1) * parseInt(data[2], 10);
      }

      return offset;
    }
  }
})();
